import * as React from 'react';
import {AutoSizer, MultiGrid} from 'react-virtualized';
import "./style.css";
import "../tableStyle.css";
import {InputNumber, Spin} from "antd";
import {EmptyTable} from "../EmptyTable";
import {LoadingOutlined} from "@ant-design/icons";
import {Trans} from 'react-i18next';

const STYLE = {
  borderRadius: '0 0 5px 0'
};


export default class ValueTable extends React.PureComponent {

  constructor(props, context) {
    super(props, context);

    this.state = {
      fixedColumnCount: 1,
      fixedRowCount: 1,
      scrollToColumn: 0,
      scrollToRow: 0,
      editColumn: null,
      editRow: null,
      value: null
    };

    this._cellRenderer = this._cellRenderer.bind(this);
    this._onScrollToRowChange = this._createEventHandler('scrollToRow');
    // this.changeValue = debounce(this.changeValue, 500);
    this.editField = React.createRef()
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  changeValue = (value) => {
    this.setState({
      value: value
    })
    // this.props.rows[data.rowIndex - 1][data.columnIndex] = data.value
    this.multiGridRef.forceUpdateGrids()
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  updateValue = (data) => {
    const {columns, rows, allAvailable, onChange} = this.props
    if(rows[data.rowIndex - 1][data.columnIndex] !== data.value) {
      onChange({
        value: data.value,
        row: data.rowIndex - 1,
        col: data.columnIndex,
        tab: this.props.tabIndex,
        materialId: allAvailable[rows[data.rowIndex - 1][0]][columns[data.columnIndex]]
      }).then(()=>{
        this.multiGridRef.forceUpdateGrids()
      })
    }
  }

  refreshGrid = () => {
    if(this.multiGridRef) {
      this.multiGridRef.forceUpdateGrids()
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(prevState.editColumn && this.state.editColumn && prevState.editColumn !== this.state.editColumn ||
      prevState.editRow && this.state.editRow && prevState.editRow !== this.state.editRow
    ) {
      this.updateValue({rowIndex: prevState.editRow, columnIndex: prevState.editColumn, value: prevState.value})
    }
    if(!prevProps.updateTable && this.props.updateTable) {
      this.props.setUpdateTable(false)
      this.refreshGrid()
    }
    if(prevProps.activeLoadingTabs[this.props.tabIndex] && !this.props.activeLoadingTabs[this.props.tabIndex]) {
      this.refreshGrid()
    }
  }

  handleClickOutside(event) {
    if (!event.defaultPrevented) {
      if (this.state.editColumn && this.editField && this.editField.current && !this.editField.current.contains(event.target)) {
        this.updateValue({rowIndex: this.state.editRow, columnIndex: this.state.editColumn, value: this.state.value})
        this.setState({
          editColumn: null,
          editRow: null,
          value: null
        }, ()=> {
          this.refreshGrid()
        })
      }
    }
  }

  getClassName = (rowIndex, columnIndex) => {
    const {columns, rows, allAvailable} = this.props
    if (rowIndex > rows.length) {
      return "laserSpeedDisabledRow"
    }
    if (rowIndex === 0) {
      return "laserSpeedZeroRow"
    } else {
      if (columnIndex === 0) {
        return "laserSpeedLeftColumn"
      } else {
        let row = rows[rowIndex - 1]
        let name = row[0]
        let value = row[columnIndex]
        if (!value) {
          if (allAvailable[name][columns[columnIndex]]) {
            return "laserSpeedOddRow"
          } else {
            return "laserSpeedDisabledRow"
          }
        } else {
          return "laserSpeedOddRow"
        }
      }
    }
  }

  render() {
    const {columns, rows, tabIndex, activeLoadingTabs} = this.props;
    if (rows.length === 0) {
      return (
        <React.Fragment>
          <Spin spinning={Boolean(activeLoadingTabs && activeLoadingTabs[tabIndex])}
                indicator={<LoadingOutlined style={{ fontSize: 48, transform: "translate(-50%, -50%)" }} spin />}
          >
            <EmptyTable/>
          </Spin>
        </React.Fragment>
        )
    } else {
      return (
        <React.Fragment>
          <Spin spinning={Boolean(activeLoadingTabs && activeLoadingTabs[tabIndex])}
                indicator={<LoadingOutlined style={{ fontSize: 48, transform: "translate(-50%, -50%)" }} spin />}
          >
            <AutoSizer disableHeight>
              {({width}) => (
                <MultiGrid
                  ref={(grid) => {
                    this.multiGridRef = grid;
                  }}
                  {...this.state}
                  cellRenderer={this._cellRenderer}
                  columnWidth={this._getColumnWidth}
                  columnCount={this._getColumnCount(columns, width)}
                  enableFixedColumnScroll
                  enableFixedRowScroll
                  height={260}
                  rowHeight={35}
                  rowCount={rows.length < 6 ? 7 : rows.length+1}
                  style={STYLE}
                  classNameTopLeftGrid={"topLeftGrid"}
                  classNameTopRightGrid={"topRightGrid"}
                  classNameBottomLeftGrid={"bottomLeftGrid"}
                  classNameBottomRightGrid={"bottomRightGrid"}
                  width={width}
                  hideTopRightGridScrollbar
                  hideBottomLeftGridScrollbar
                />
              )}
            </AutoSizer>
          </Spin>
        </React.Fragment>
      );
    }
  }

  _cellRenderer({columnIndex, key, rowIndex, style}) {
    const {columns, rows} = this.props
    const {editColumn, editRow} = this.state;
    return (
      <div ref={ref => this.editField.current = ref} onClick={(e) => {
        if(rowIndex !== 0) {
          e.preventDefault()
          this.handleEditShow(columnIndex, rowIndex, rows[rowIndex - 1][columnIndex])
        }
      }} className={this.getClassName(rowIndex, columnIndex)}
           key={key} style={{
        ...style,
        padding: 5,
        borderTop: rowIndex === 0 ? "1px solid #888888" : "none",
        borderBottom: '1px solid #888888',
        borderRight: '2px solid #001529',
        display: 'inline-block',
        alignItems: 'center',
        right: -2
      }}>
        <div style={{fontSize: 13}} className={"cellText"}>
          {rowIndex === 0 ?
            <div className={"speedTableCellText"}>{columns[columnIndex]}</div>
            :
            (rows.length < rowIndex ?
              null
              :
              <div>
                {
                  editColumn && editRow && editColumn === columnIndex && editRow === rowIndex ?
                    <React.Fragment>
                      <div>
                        <InputNumber
                          ref={(input) => {
                            this.nameInput = input;
                          }}
                          className={"laserSpeedTableInput"}
                          step={0.1}
                          min={0}
                          defaultValue={rows[rowIndex - 1][columnIndex]}
                          style={{width: "100%", marginLeft: -5, fontSize: 13, lineHeight: 1.5}}
                          formatter={value => `${value}`.replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1')}
                          onChange={(value) => {
                            this.changeValue(value)
                          }}
                          bordered={false}
                        />
                      </div>
                    </React.Fragment>
                    :
                    (columnIndex === 0 ?
                        <div className={"speedTableCellLeft yesSelect"}><Trans>{rows[rowIndex - 1][columnIndex]}</Trans></div>
                        :
                        <div className={"speedTableCellText"}>{rows[rowIndex - 1][columnIndex]}</div>
                    )
                }
              </div>
            )
          }
        </div>
      </div>
    );
  }

  handleEditShow = (columnIndex, rowIndex, value) => {
    this.setState({
      editColumn: columnIndex,
      editRow: rowIndex,
      value: value
    }, () => {
      if (this.nameInput) {
        this.nameInput.focus();
      }
    })

    this.multiGridRef.forceUpdateGrids()
  }

  _getColumnWidth = ({index}) => {
    return index === 0 ? 140 : 55
  };

  _createEventHandler(property) {
    return event => {
      const value = parseInt(event.target.value, 10) || 0;

      this.setState({
        [property]: value,
      });
    };
  }

  _getColumnCount = (columns, width) =>  {
    const count = Object.keys(columns).length
    if(140 + (count-1) * 55 < width) {
      return Math.floor((width-140)/55) + 1
    }
    else {
      return count
    }
  }
}